import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MatAccordion, MatExpansionPanel} from '@angular/material/expansion';
import {buildItem, calculateOrderMaterialItemValue} from './OrderAddUtils';
import {OrderEntryComponent} from './order-entry.component';
import {MatIcon} from '@angular/material/icon';
import {AsyncPipe, CurrencyPipe} from '@angular/common';
import {MatFabButton} from '@angular/material/button';



@Component({
    selector: 'app-order-entry-array',
    templateUrl: './order-entry-array.component.html',
    imports: [
        OrderEntryComponent,
        MatExpansionPanel,
        MatAccordion,
        MatIcon,
        AsyncPipe,
        CurrencyPipe,
        MatFabButton
    ],
    styleUrls: ['./order-entry-array.component.scss']
})
export class OrderEntryArrayComponent implements OnInit {


    @ViewChild('accordion', {static: true}) accordion: MatAccordion;
    public total$: Observable<number>;
    @Input()
    public currency: string;
    @Input()
    public itemsFormArray: UntypedFormArray;

    get controls() {
        return this.itemsFormArray.controls as UntypedFormGroup[];
    }

    ngOnInit() {
        this.total$ = this.itemsFormArray.valueChanges.pipe(
            map((entryArray) => {
                return entryArray
                    .map((item) => calculateOrderMaterialItemValue(item.costEach, item.quantity, item.discount))
                    .reduce((a, b) => a + b, 0);
            }));
        if (this.accordion) this.accordion.openAll();
    }

    addItem(item?) {
        this.itemsFormArray.push(buildItem(item));
    }

    removeItem(item) {
        console.log('removing item:', item);
        this.itemsFormArray.removeAt(item);
    }
}


